/**
 * Centralized application configuration
 *
 * This file provides access to all environment variables in a centralized way,
 * facilitating their management and consistent use throughout the application.
 */

// List of required environment variables
const requiredEnvs = ['REACT_APP_API_HOST'];

// Verify required environment variables
requiredEnvs.forEach((env) => {
  if (!process.env[env]) {
    console.error(`Error: Missing required environment variable: ${env}`);
  }
});

// Base URL variables according to environment
const getApiUrl = () => {
  return process.env.REACT_APP_API_HOST;
};

// Determine if we are in development mode
const isDevelopment = process.env.NODE_ENV === 'development';

// Central configuration
const config = {
  // Basic application information
  app: {
    title: process.env.REACT_APP_TITLE || 'ECA',
    stage: process.env.REACT_APP_STAGE || 'development',
    domain: process.env.REACT_APP_APP_DOMAIN || 'dev.app.silia.com',
    environment: process.env.NODE_ENV || 'development',
    countTime: parseInt(process.env.REACT_APP_COUNT_TIME || '15', 10),
    smartCountTime: parseInt(process.env.REACT_APP_SMART_COUNT_TIME || '80', 10),
    noReplyEmail: process.env.REACT_APP_NO_REPLY_EMAIL,
  },

  // Base URLs
  urls: {
    api: getApiUrl(),
    websocket: process.env.REACT_APP_WS_URL,
    websocketShared: process.env.REACT_APP_WS_SHARED_URL,
    voiceAgentWebsocket:
      process.env.REACT_APP_VOICE_AGENT_WS_URL ||
      `wss://voice-agent.${process.env.REACT_APP_APP_DOMAIN}/`,
    resetPassword: `${process.env.REACT_APP_APP_DOMAIN}/resetPassword`,
    inboxsocket: process.env.REACT_APP_WS_WEB_INBOX,
    chatbotWebsocket: process.env.REACT_APP_WS_WEB_CHATBOT,
  },

  // API Endpoints (built from the base URL)
  endpoints: {
    users: `${getApiUrl()}/user`,
    teams: `${getApiUrl()}/teams`,
    folders: `${getApiUrl()}/folders/folders`,
    access: `${getApiUrl()}/access`,
    permissions: `${getApiUrl()}/permissions`,
    auth: `${getApiUrl()}/auth`,
    chatbot: `${getApiUrl()}/chatbot`,
    conversations: `${getApiUrl()}/conversations`,
    messages: `${getApiUrl()}/messages`,
    accounts: `${getApiUrl()}/accounts`,
    flows: `${getApiUrl()}/flows`,
    docMiner: `${getApiUrl()}/docMiner`,
    resetPassword: `${getApiUrl()}/notification`,
    metrics: `${getApiUrl()}/metrics`,
    assistants: `${getApiUrl()}/chatbot`,
    modules: `${getApiUrl()}/modules`,
    billing: `${getApiUrl()}/billing`,
    evals: `${getApiUrl()}/evals`,
    voice: `${getApiUrl()}/voice`,
  },

  stripe: {
    publicKey: process.env.REACT_APP_STRIPE_PUBLIC_KEY,
  },

  // email templates
  sender: {
    email: process.env.REACT_APP_NO_REPLY_EMAIL,
  },

  // Analytics and tracking services
  analytics: {
    googleAnalyticsId: process.env.REACT_APP_GOOGLE_ANALYTICS_ID || 'G-3XWK284N22',
    ga4MeasurementId: process.env.REACT_APP_GA4_MEASUREMENT_ID || 'G-3XWK284N22',
    hotjarId: process.env.REACT_APP_HOTJAR_ID || '6445221',
    googleTagManagerId: process.env.REACT_APP_GTM_ID || 'GTM-MDDWHRKS',
  },

  // Helpers and state
  isDevelopment,
  isProduction: process.env.NODE_ENV === 'production',
  isStaging: process.env.REACT_APP_STAGE === 'staging',
};

export default config;
